











































































import Vue from "vue";
import axios from "axios";
import store from "@/store";
import router from "@/router";
import NewServiceRequirementModal from "@/modals/NewServiceRequirementModal.vue";
import ServiceRequirementPreview from "@/modals/ServiceRequirementPreview.vue";
import { format, parseISO, parse } from "date-fns";

export default Vue.extend({
	components: {
		NewServiceRequirementModal,
		ServiceRequirementPreview
	},
    data(){ return {
		usersServiceRequirements: [],
		choices: [] as any,
		tableLoading: true as boolean,
		worker: {} as any,
		previewData: {} as any
	}},

    mounted(){
		this.getWorkerData();
		this.getUserServiceRequirementChangeChoices();
    },

    computed:{
        storeJwt() {
			return this.$store.state.jwt;
		},
      isMobile() {
         return store.state.isMobile;
      }
    },

    methods: {
        getUserServiceRequirements(){
            axios.get(`palvelutarpeenarviointi/serviceRequirements/${this.worker.uid}`, {'headers': {"jobseekerId": this.worker.uid}}).then((resp) => {
                this.usersServiceRequirements = resp.data;
				this.tableLoading = false;
			});
        },

		getUserServiceRequirementChangeChoices(){
            axios.get("palvelutarpeenarviointi/serviceRequirementChangeChoices").then((resp) => {
                resp.data.forEach((choice: any) => {
					let option: any = {};
					switch (this.$store.state.lang) {
						case 'fi':
							option = {
								text: choice.teksti,
								value: choice.uid,
							};
							break;
						case 'en': 
							option = {
								text: choice.tekstiEnglanti,
								value: choice.uid,
							};
							break;
						case 'se':
							option = {
								text: choice.tekstiRuotsi,
								value: choice.uid,
							};
							break;
						default:
							option = {
								text: choice.teksti,
								value: choice.uid,
							};
							break;
					}
					this.choices.push(option);  
				});
			});
        },

		async getWorkerData() {
			await axios.get("Itsepalvelu/user").then((resp) => {
				this.worker = resp.data;
				this.getUserServiceRequirements();
			});
      	},

		showNewServiceRequirementModal() {
			this.$bvModal.show("service-requirement");
		},

		showServiceRequirementPreview(data: any){
			this.previewData = data;
			this.$bvModal.show("service-requirement-preview");
		},

		addNewServiceRequirement(){
			this.showNewServiceRequirementModal(); 
		},

		formatDate(date: any){
			let parsed = parseISO(date);
			return format(parsed, 'dd.MM.yyyy');
		},

		formatSituation(situation: number){
			if(situation === 1){
                return "yes"
            }else if(situation === 2){
                return "service-requirement-modal.some-changes"
            }else if(situation === 3){
				return "service-requirement-modal.changes"
			}else{
				return "dash"
			}
		},

		generateChoicesString(index: number){
			const serviceRequirement = this.usersServiceRequirements[index];
			const {palvelutarpeenArvioinninMuutosValinnat}: any = serviceRequirement;

			if(Object.keys(serviceRequirement).length <= 0){
				return "";
			}

			const correntLanguages: any[] = palvelutarpeenArvioinninMuutosValinnat.map((r: any) => {
				if(this.$store.state.lang === 'en'){
					return {
						uid: r.uid,
						text: r.tekstiEnglanti
					}
				}else if(this.$store.state.lang === 'se'){
					return {
						uid: r.uid,
						text: r.tekstiRuotsi
					}
				}else{
					return {
						uid: r.uid,
						text: r.teksti
					}
				}
			})

			return correntLanguages.map(r => r.text).join(", \n");
		}
    },

    watch: {
		storeJwt: {
			handler: async function handle(newVal) {
				if (newVal) {
					try {
						const resp = await axios.get("auth/TestAuth");
					} catch (error) {
						router.push({
							name: "Home",
							params: {
								org: store.state.org as string,
							},
						});
					}
				} else {
					router.push({
						name: "Home",
						params: {
							org: store.state.org as string,
						},
					});
				}
			},
			immediate: true,
		},
	},

});
